import { AI_TOOLS_TYPE } from '../../../constants/ai-event-type';
import qualityEventsHelpers from '../quality-events.helpers';

export const AI_QUALITY_EVENTS = {
    trackEvent: (event: string, extra: string | object, id?: string | number | null) => {
        const data: Record<string, string> = {
            extra: typeof extra === 'object' ? JSON.stringify(extra) : extra,
            type: event
        }

        if (id) {
            data.item_id = id as string
        }

        return qualityEventsHelpers.track(data);
    },
    trackError: (event: string, type: string, extra: string | undefined, id: string | number | null) => {
        qualityEventsHelpers.track({
            extra,
            item_id: id,
            type: `${event}:${type}`
        });
    },
    ideaCard(ideaMsg: string) {
        qualityEventsHelpers.track({
            extra: ideaMsg,
            type: `${AI_TOOLS_TYPE.TRACK}:ideaCard`
        });
    }
};
